import React from 'react';
import { PreImg } from 'common/src/components';
import { IconImg } from '../../images';

export enum CHECKBOX_CHECK_TYPE {
    UN_CHECK,
    IS_CHECK,
    UNKNOWN_CHECK,
}
type ICheckboxMap = {
    [propName in CHECKBOX_CHECK_TYPE]: string;
};
interface ICheckboxProps {
    isChecked: CHECKBOX_CHECK_TYPE;
    disabledCheck?: boolean;
    onChange: (isCheck: boolean) => void;
}

const checkboxMap: ICheckboxMap = {
    [CHECKBOX_CHECK_TYPE.UN_CHECK]: IconImg.CheckboxNormalIcon,
    [CHECKBOX_CHECK_TYPE.IS_CHECK]: IconImg.CheckBoxIcon,
    [CHECKBOX_CHECK_TYPE.UNKNOWN_CHECK]: IconImg.CheckUnknownIcon,
};

export const Checkbox = (props: ICheckboxProps) => {
    const { isChecked, disabledCheck = false, onChange } = props;
    const onClick = (e: React.MouseEvent) => {
        e.preventDefault();
        e.stopPropagation();
        if (!disabledCheck) {
            onChange(!isChecked);
        }
    };
    return (
        <PreImg>
            <img
                onClick={onClick}
                className={`icon-img-check ${
                    isChecked === CHECKBOX_CHECK_TYPE.UNKNOWN_CHECK ? 'icon-img-check-unknown' : ''
                }`}
                src={checkboxMap[isChecked]}
            />
        </PreImg>
    );
};
